(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-content"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  // Accordion
  $(".accordion-toggle").on("click", function(){
    var $item = $(this).closest(".accordion-item");
    var $body = $item.find(".accordion-body");
    var $icon = $(this).find(".accordion-icon");

    $(".accordion-item").not($item).removeClass("active").find(".accordion-body").slideUp();
    $(".accordion-item").not($item).find(".accordion-icon").text("+");

    $item.toggleClass("active");
    $body.stop(true,true).slideToggle();
    $icon.text($item.hasClass("active") ? "–" : "+");
  });

  // Video Play/Pause
  $(".play-btn").on("click", function(){
    var $wrapper = $(this).closest(".video-wrapper");
    var $poster = $wrapper.find(".video-poster");
    var $video = $wrapper.find("video")[0];

    $poster.hide();
    $($video).show();
    $video.play();

    $video.onpause = function(){
      $($video).hide();
      $poster.show();
    };
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $(".faq-question").click(function(){
    let parent = $(this).parent();

    if(parent.hasClass("active")){
      parent.removeClass("active");
      parent.find(".faq-answer").slideUp(300);
    //   parent.find(".icon").text("+");
    } else {
      $(".faq-item").removeClass("active");
      $(".faq-answer").slideUp(300);
    //   $(".faq-item .icon").text("+");

      parent.addClass("active");
      parent.find(".faq-answer").slideDown(300);
    //   parent.find(".icon").text("–");
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["favorite-products"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.favorite-products__slider').slick({
      arrows: true,
      prevArrow: $('.favorite-prev'),
      nextArrow: $('.favorite-next'),
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      fade: true,
      cssEase: 'linear'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
